<template>
    <div>
        <div>
            <Table :columns="tblColumns" :data="tblData" size="small" :loading="isLoading" class="adminRequestsList" />
        </div>
        <Page
            :total="totalCount"
            :current="currentPage"
            :page-size="totalPerPage"
            class="pagination"
            @on-change="handleOnpageChanged"
        />
        <AdminViewProjectLogDisputeModal ref="ViewRequest" @reload="handleReloadList" />
    </div>
</template>

<script>
import moment from 'moment';
import AdminViewProjectLogDisputeModal from '@/components/Requests/Admin/ProjectLogDispute/AdminViewProjectLogDisputeModal';

export default {
    components: { AdminViewProjectLogDisputeModal },
    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
        requestsDataList: {
            type: Array,
            default: () => [],
        },
        currentPage: {
            type: Number,
            default: 0,
        },
        totalCount: {
            type: Number,
            default: 0,
        },
        totalPerPage: {
            type: Number,
            default: 0,
        },
    },

    data() {
        return {
            tblColumns: [
                {
                    title: 'Date Submitted',
                    key: 'createdAt',
                    width: 150,
                    render: (h, params) => {
                        return h(
                            'div',
                            params.row.createdAt ? moment(params.row.createdAt).utc().format('YYYY-MM-DD') : ''
                        );
                    },
                },
                {
                    title: 'Timelog Date',
                    key: 'requestedStart',
                    width: 150,
                    render: (h, params) => {
                        return h(
                            'div',
                            params.row.requestedStart
                                ? moment(params.row.requestedStart).utc().format('YYYY-MM-DD')
                                : ''
                        );
                    },
                },
                {
                    title: 'Employee',
                    key: 'user',
                    width: 150,
                    render: (h, params) => {
                        return h('div', params.row.user ? params.row.user.name : '-');
                    },
                },
                {
                    title: 'Project',
                    key: 'project',
                    width: 150,
                    render: (h, params) => {
                        return h(
                            'div',
                            params.row.currentData && params.row.currentData.project
                                ? params.row.currentData.project.name
                                : '-'
                        );
                    },
                },
                {
                    title: 'Initial Time',
                    key: 'initialTime',
                    width: 180,
                    render: (h, params) => {
                        return params.row.currentData
                            ? h(
                                  'div',
                                  `${moment(params.row.currentData.startTime).utc().format('hh:mm A')} - ${moment(
                                      params.row.currentData.endTime
                                  )
                                      .utc()
                                      .format('hh:mm A')}`
                              )
                            : h('div', { class: 'hyphenFont' }, '-');
                    },
                },
                {
                    title: 'Requested Time',
                    key: 'requestedTime',
                    width: 180,
                    render: (h, params) => {
                        return h(
                            'div',
                            `${moment(params.row.requestedStart).utc().format('hh:mm A')} - ${moment(
                                params.row.requestedEnd
                            )
                                .utc()
                                .format('hh:mm A')}`
                        );
                    },
                },
                {
                    title: 'Status',
                    key: 'status',
                    width: 120,
                    align: 'center',
                    render: (h, params) => {
                        const status = params.row.status;
                        let color = '';
                        if (status === 'pending') color = 'warning';
                        else if (status === 'approved') color = 'success';
                        else if (status === 'rejected') color = 'error';
                        else if (status === 'cancelled') color = 'default';

                        return h(
                            'Tag',
                            {
                                props: {
                                    color: color,
                                },
                            },
                            status.toUpperCase()
                        );
                    },
                },
                {
                    title: 'Action',
                    key: 'action',
                    width: 100,
                    align: 'center',
                    render: (h, params) => {
                        return h('div', [
                            h(
                                'Button',
                                {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                    },
                                    on: {
                                        click: () => {
                                            this.handleView(params.row);
                                        },
                                    },
                                },
                                'View'
                            ),
                        ]);
                    },
                },
            ],
        };
    },
    computed: {
        tblData() {
            return this.requestsDataList;
        },
    },
    methods: {
        handleView(row) {
            this.$refs.ViewRequest.openModal(row);
        },
        handleReloadList() {
            this.$emit('reload');
        },
        handleOnpageChanged(page) {
            this.$emit('on-page-change', page);
        },
    },
};
</script>

<style lang="scss" scoped>
.adminRequestsList {
    margin-top: 20px;
}
.pagination {
    margin-top: 20px;
    text-align: right;
}
</style>
